import { defineStore } from "pinia";
import http from "@/http";
import {
  LIST_ORCAMENTO,
  ADD_ORCAMENTO,
  UPDATE_ORCAMENTO,
  DEL_ORCAMENTO,
  LIST_ITEM_ORCAMENTO,
  ADD_ITEM_ORCAMENTO,
  UPDATE_ITEM_ORCAMENTO,
  DEL_ITEM_ORCAMENTO
} from "@/http/url";

export const useOrcamentoStore = defineStore("OrcamentoStore", {
  state: () => {
    return {
      orcamentos: [],
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_ORCAMENTOS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_ORCAMENTO)
          .then((response) => {
            this.orcamentos = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_ORCAMENTO(orcamento) {
      return new Promise((resolve, reject) => {
        http
          .post(ADD_ORCAMENTO, orcamento)
          .then((response) => {
            this.orcamentos.push(response.data);
            resolve("Ok");
          })
          .catch((erro) => {
            console.log(erro);
            reject(erro);
          });
      });
    },

    ALTERAR_ORCAMENTO(orcamento) {
      return http
        .put(`${UPDATE_ORCAMENTO + orcamento.id}`, orcamento)
        .then((response) => {
          orcamento.itens.forEach((item) => {
            if (item.id != 0) {
              this.ALTERAR_ITEM_ORCAMENTO(item);
            } else {
              this.CADASTRAR_ITEM_ORCAMENTO(orcamento.id, item);
            }
          });
          //Atualiza a lista atual
          const index = this.orcamentos.findIndex((orc) => {
            return orc.id === orcamento.id;
          });
          this.orcamentos[index] = response.data;
          
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_ORCAMENTO(id) {
      return http
        .delete(`${DEL_ORCAMENTO + id}`)
        .then(() => (this.orcamentos = this.orcamentos.filter((orc) => orc.id != id)));
    },

    // OPERAÇÕES COM ITENS DE ORÇAMENTO
    LISTAR_ITEM_ORCAMENTO(orcamento) {
      return http
        .get(`${LIST_ITEM_ORCAMENTO + orcamento.id}`)
        .then((response) => {
          const index = this.orcamentos.findIndex((orc) => {
            return orc.id === orcamento.id;
          });
          this.orcamentos[index].itens = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    CADASTRAR_ITEM_ORCAMENTO(id, item) {
      return http.post(`${ADD_ITEM_ORCAMENTO + id}`, item).catch((erro) => {
        console.log(erro);
      });
    },

    ALTERAR_ITEM_ORCAMENTO(item) {
      return http.put(`${UPDATE_ITEM_ORCAMENTO + item.id}`, item).catch((erro) => {
        console.log(erro);
      });
    },

    REMOVER_ITEM_ORCAMENTO(id) {
      return http.delete(`${DEL_ITEM_ORCAMENTO + id}`);
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getOrcamentos() {
      return this.orcamentos;
    },

    getOrcamentoLoad(state) {
      return state.loaded;
    },

    getLastOrcamento: (state) => {
      return state.orcamentos[state.orcamentos.length - 1];
    },

    getOrcamento: (state) => {
      return (id) => state.orcamentos.find((o) => o.id === id);
    },

    getFilterOrcamentos: (state) => {
      return (filtro) => {
        let filtrada = state.orcamentos;

        if (filtro.id != 0) {
          filtrada = filtrada.filter((o) => !filtro || o.id == filtro.id);
        }

        if (filtro.total != 0.0) {
          filtrada = filtrada.filter((o) => !filtro || o.total == filtro.total);
        }

        filtrada = filtrada.filter(
          (o) =>
            !filtro ||
            (o.titulo.includes(filtro.titulo) &&
              o.cliente.includes(filtro.cliente) &&
              o.status.includes(filtro.status))
        );

        return filtrada;
      };
      //return (filtro) => state.orcamentos.filter((o) => !filtro || o.titulo.includes(filtro));
    },
  },
});
